import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';
import { Icon, type IconName } from './icon';

export type BtnVariant = '' | 'primary' | 'ghost' | 'danger' | 'danger solid' | 'good' | 'link';
export interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  v?: BtnVariant | string;
  size?: '' | 'xs' | 'sm' | 'lg';
  icon?: IconName;
  children?: ReactNode;
}

export function Btn({ v = '', size = '', icon, children, className, type = 'button', ...p }: BtnProps) {
  return (
    <button type={type} className={cx('btn', v, size, !children && icon && 'icon', className)} {...p}>
      {icon && <Icon n={icon} s={size === 'xs' ? 13 : size === 'sm' ? 14 : 16} />}
      {children}
    </button>
  );
}
